import { atom } from "recoil"

const formReadyState = atom({
  key: "formReadyState",
  default: {
    screeningOption: false,
    property: false,
    applicant: false,
  },
})

const formReadyStateV2 = atom({
  key: "formReadyStateV2",
  default: {
    screeningOption: false,
    property: false,
    applicant: false,
  },
})


export { formReadyState, formReadyStateV2 }
